// extracted by mini-css-extract-plugin
export default {"creditCardLine":"styles_creditCardLine__GB+pb","image":"styles_image__EWPHN","paypalImage":"styles_paypalImage__TNZYn","newCreditCard":"styles_newCreditCard__xfGFD"};